import createReducer from '../lib/createReducer'
import * as types from '../actions/types'

export const user_info = createReducer(false,{
	[types.USER_INFO](state, action){
		let newState = action.payload
		return newState
	}
})
